import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 6,
    type: CHECKLIST_ITEM_TYPE.LEAD_NEXT_ACTION,
    manifestKey: 'LEAD_NEXT_ACTION',

    try_it: {
        button_label: 'Select Next Action',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'LeadNextActionCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { resolved_action: 'BOOK' },
        },
    },
    pre_flight_diff: [
        'Dropdown shows next actions available for current lead status',
        'User selects a resolved_action string',
        'Checklist item: PENDING → YES',
        'resolved_action stored in response_payload for audit trail',
        'No BE-enforced forward action — resolved_action is informational only',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'POST resolved_action=GARBAGE_STRING',
            body: {
                completion_state: 'YES',
                response_payload: { resolved_action: 'GARBAGE_STRING' },
            },
            expected: '200 accepted — no whitelist validation on BE (out-of-scope ticket #2)',
        },
        {
            label: 'POST resolved_action missing',
            body: { completion_state: 'YES', response_payload: {} },
            expected: '400 — resolved_action is required for LEAD_NEXT_ACTION',
        },
    ],
};
